import { useMutation, useQueryClient } from '@tanstack/react-query';
import { RequestWithdrawQueryKeys } from '../constants';
import { WithdrawRequestService, CreateWithdrawRequestDto, CreateWithdrawRequestEntity } from 'services/openapi';

export const useCreateRequestWithdrawMutation = () => {
  const queryClient = useQueryClient();

  const { isLoading, error, data, isError, isSuccess, mutate, mutateAsync } = useMutation<
    CreateWithdrawRequestEntity,
    Error,
    CreateWithdrawRequestDto
  >({
    mutationFn: (variables: CreateWithdrawRequestDto) => {
      return WithdrawRequestService.withdrawRequestControllerCreate(variables);
    },
    onSuccess: () => Promise.all([queryClient.invalidateQueries([RequestWithdrawQueryKeys.CREATE_REQUEST_WITHDRAW])]),
  });

  return {
    isLoading,
    isSuccess,
    error,
    data,
    isError,
    mutate,
    mutateAsync,
  };
};
